module.exports = __webpack_public_path__ + "static/media/sound-timer.5b8f4f06.mp4";